import React from 'react';
import ShortInterestWidgetRenderer from './ShortInterestWidgetRenderer';

const Preview: React.FC = () => (
  <ShortInterestWidgetRenderer config={{}} />
);

export default Preview;
